import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M148.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4,10.7,5.4,18,1.6S150.9,95.4,148.2,90.7Z" />
                    <rect x="147.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="90" y="23" width="59" height="10" />
            </g>
            <g>
                <g>
                    <path d="M36.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S7.4,99.8,10,104.5s10.7,5.4,18,1.6S38.9,95.4,36.2,90.7Z" />
                    <rect x="35.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M110.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S81.4,99.8,84,104.5s10.7,5.4,18,1.6S112.9,95.4,110.2,90.7Z" />
                    <rect x="109.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="35" y="23" width="76" height="10" />
                <rect x="90" y="37" width="21" height="10" />
                <circle cx="47" cy="96" r="4" />
            </g>
        </svg>
    );
}
